import { findParentNodeOfType, hasParentNodeOfType } from 'prosemirror-utils';
import { NoteAttrs } from '../const';
import { noteContentType, noteTitleType, noteType } from '../utils';
export function isInsideYfmNote(state) {
    return hasParentNodeOfType(noteType(state.schema))(state.selection);
}
const createYfmNoteNode = (schema) => (type, content) => {
    return noteType(schema).create({
        [NoteAttrs.Class]: `yfm-note yfm-accent-${type}`,
        [NoteAttrs.Type]: type,
    }, [
        noteTitleType(schema).createAndFill(),
        noteContentType(schema).createAndFill({}, content),
    ]);
};
export const createYfmNote = (state, dispatch) => {
    const parent = findParentNodeOfType(state.schema.nodes.paragraph)(state.selection);
    if (parent) {
        const yfmNote = createYfmNoteNode(state.schema)('info', parent.node);
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(state.tr.replaceWith(parent.pos, parent.pos + parent.node.nodeSize, yfmNote));
        return true;
    }
    return false;
};
export const toYfmNote = {
    isEnable(state) {
        return createYfmNote(state);
    },
    run(state, dispatch) {
        createYfmNote(state, dispatch);
    },
};
